import { CheckCircle2, Circle, Wallet, DollarSign, Package, ShieldCheck } from "lucide-react";

const STEPS = [
  { key: "pending", label: "Created", icon: Package, done: () => true },
  { key: "in_progress", label: "Escrow Funded", icon: Wallet, done: (s) => ["in_progress", "delivered", "released", "disputed", "admin_review", "partially_released"].includes(s) },
  { key: "delivered", label: "Delivered", icon: ShieldCheck, done: (s) => ["delivered", "released", "disputed", "admin_review", "partially_released"].includes(s) },
  { key: "released", label: "Payment Released", icon: DollarSign, done: (s) => ["released", "partially_released"].includes(s) },
];

function isActive(status, key) {
  if (status === "pending") return key === "pending";
  if (status === "in_progress") return key === "in_progress";
  if (status === "delivered") return key === "delivered";
  if (status === "released" || status === "partially_released") return key === "released";
  if (status === "disputed" || status === "admin_review") return key === "delivered";
  return false;
}

export default function EscrowTimeline({ status }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-0 relative"
      data-testid="escrow-timeline"
    >
      {STEPS.map((step, i) => {
        const done = step.done(status);
        const active = isActive(status, step.key);
        const Icon = step.icon;
        return (
          <div key={step.key} className="flex md:flex-col items-center md:items-center gap-3 md:gap-2 flex-1 relative">
            <div
              className={`h-11 w-11 rounded-full flex items-center justify-center border transition-all ${
                active
                  ? "nexus-gradient border-transparent shadow-[0_0_20px_rgba(157,78,221,0.5)]"
                  : done
                  ? "bg-nexus-purple/20 border-nexus-purple/50 text-nexus-purple"
                  : "bg-white/[0.02] border-white/10 text-zinc-600"
              }`}
              data-testid={`escrow-step-${step.key}`}
            >
              <Icon className="h-5 w-5" />
            </div>
            <div className="md:text-center">
              <div className={`text-xs uppercase tracking-widest font-bold ${active ? "text-white" : done ? "text-zinc-300" : "text-zinc-600"}`}>
                {step.label}
              </div>
            </div>
            {i < STEPS.length - 1 && (
              <div className="hidden md:block absolute top-5 left-[calc(50%+22px)] right-[calc(-50%+22px)] h-px bg-white/10">
                <div
                  className={`h-full transition-all duration-700 ${done && STEPS[i + 1].done(status) ? "nexus-gradient w-full" : "w-0"}`}
                />
              </div>
            )}
          </div>
        );
      })}
      {status === "disputed" && (
        <div className="absolute -bottom-8 left-0 right-0 text-center text-xs uppercase tracking-widest text-nexus-pink font-bold">
          ⚠ Dispute opened — try to settle or escalate
        </div>
      )}
      {status === "admin_review" && (
        <div className="absolute -bottom-8 left-0 right-0 text-center text-xs uppercase tracking-widest text-nexus-pink font-bold">
          ⚖ Under Nexus admin review
        </div>
      )}
      {status === "partially_released" && (
        <div className="absolute -bottom-8 left-0 right-0 text-center text-xs uppercase tracking-widest text-emerald-300 font-bold">
          ✓ Partial settlement completed
        </div>
      )}
    </div>
  );
}
